/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcfOrgUnassignResourceSpec { 
    /**
     * Resource Id
     */
    resource_id: string;
    /**
     * Org Id
     */
    vcf_org_id: string;
    partial?: boolean;
}

